import React, {useState} from 'react';
import {Modal, ModalBody} from "react-bootstrap";
import Rating from "../routes/product/Rating";
import {createUserFeedback} from "../services/UserRepository";

export function CourseFeedback({show, setShow}) {
    const [feedback, setFeedback] = useState("");

    const [rating, setRating] = useState(0);


    return (
        <Modal show={show} centered={true} onHide={() => setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>
                    Gi tilbakemelding
                </Modal.Title>
            </Modal.Header>

            <ModalBody>
                <div className={"d-flex flex-column"}>
                    <h5>Hvor godt liker du kurset fra 1-5 stjerner?</h5>
                    <Rating className={"mb-3"} initRating={0} setValue={setRating}/>
                    <h5>Hva er positivt og hva kan forbedres?</h5>
                    <textarea value={feedback} className={"form-control"} placeholder={"Din tilbakemelding..."}
                              onChange={(e) => setFeedback(e.target.value)}/>
                    <button className={"btn btn-success mt-2"}
                            onClick={() => createUserFeedback(rating, feedback)}>Lagre
                    </button>
                </div>
            </ModalBody>
        </Modal>
    );
}